import {generatePath} from 'react-router';

import {useDomainConfig} from '../../../../provider/domain-config/domain-config-hook';
import {LocaleWithCatalogName} from '../../../../provider/locale/facebook-localization/locale-with-catalog-name';
import {enUs} from '../../../../provider/locale/translation/en-us/data';
import {track} from '../../../../service/analytics/analytics';
import {
    DashboardRecommendationItemType,
    DashboardRecommendationsHookType,
    DashboardRecommendationTypeEnum,
} from '../../../../service/dashboard/dashboard-recommendations/dashboard-recommendations-type';
import {ProvidersIdsEnum} from '../../../../util/type';

import {DashboardRecommendation} from './dashboard-recommendation-card/dashboard-recommendation';
import {
    getRecommendationDetailsLangKey,
    recommendationLinkAnalyticsMap,
    recommendationLinkUrl,
    recommendationSubtitles,
    recommendationTagCounterName,
    recommendationTitles,
} from './dashboard-recommendation-card/dashboard-recommendation-card-const';

type PropsType = {
    recommedation: DashboardRecommendationItemType;
    onPostponeChange: DashboardRecommendationsHookType['onPostponeChange'];
    showBottomBorder: boolean;
};

export function DashboardRecommendationItem(props: PropsType): JSX.Element {
    const {recommedation, onPostponeChange, showBottomBorder} = props;

    const {key, postponed, count, filterKey, startDate, endDate, hasAnyOlderPost} = recommedation;

    const {domainName} = useDomainConfig();

    if (key === DashboardRecommendationTypeEnum.googlePosts || key === DashboardRecommendationTypeEnum.yandexPosts) {
        const titleLangKey = hasAnyOlderPost
            ? 'DASHBOARD_PAGE__RECOMMENDATION__OLD_POSTS__TITLE'
            : 'DASHBOARD_PAGE__RECOMMENDATION__NO_POSTS__TITLE';

        const subtitleLangKey = hasAnyOlderPost
            ? 'DASHBOARD_PAGE__RECOMMENDATION__OLD_POSTS__SUBTITLE'
            : 'DASHBOARD_PAGE__RECOMMENDATION__NO_POSTS__SUBTITLE';

        const catalogId =
            key === DashboardRecommendationTypeEnum.googlePosts ? ProvidersIdsEnum.googleMaps : ProvidersIdsEnum.yandex;

        const catalogNamePlaceholder =
            key === DashboardRecommendationTypeEnum.googlePosts ? 'Google Maps' : 'Yandex Maps';

        const detailsLangKey = hasAnyOlderPost
            ? 'DASHBOARD_PAGE__RECOMMENDATION__OLD_POSTS__DETAILS'
            : 'DASHBOARD_PAGE__RECOMMENDATION__NO_POSTS__DETAILS';

        return (
            <DashboardRecommendation
                count={count}
                details={
                    <LocaleWithCatalogName
                        catalogId={catalogId}
                        namePlaceholder={catalogNamePlaceholder}
                        stringKey={detailsLangKey}
                    />
                }
                endDate={endDate}
                filterKey={filterKey}
                key={key}
                onLinkClick={() => {
                    track(
                        recommendationLinkAnalyticsMap[key],
                        enUs.DASHBOARD_PAGE__RECOMMENDATION__OLD_POSTS__TITLE.replace(
                            '{catalog}',
                            catalogNamePlaceholder
                        )
                    );
                }}
                onPostponeChange={onPostponeChange}
                path={generatePath(recommendationLinkUrl[key])}
                postponedDate={postponed ? new Date(postponed * 1000) : null}
                recommendationKey={key}
                showBottomBorder={showBottomBorder}
                startDate={startDate}
                subtitle={
                    <LocaleWithCatalogName
                        catalogId={catalogId}
                        namePlaceholder={catalogNamePlaceholder}
                        stringKey={subtitleLangKey}
                    />
                }
                tagCounterPluralLangKeys={recommendationTagCounterName[key]}
                title={
                    <LocaleWithCatalogName
                        catalogId={catalogId}
                        namePlaceholder={catalogNamePlaceholder}
                        stringKey={titleLangKey}
                    />
                }
            />
        );
    }

    return (
        <DashboardRecommendation
            count={count}
            details={
                <LocaleWithCatalogName
                    catalogId={ProvidersIdsEnum.facebook}
                    namePlaceholder="FB"
                    stringKey={getRecommendationDetailsLangKey(key, domainName)}
                />
            }
            endDate={endDate}
            filterKey={filterKey}
            key={key}
            onLinkClick={() => {
                track(
                    recommendationLinkAnalyticsMap[key],
                    enUs[recommendationTitles[key]].replace('{catalogName}', 'Facebook')
                );
            }}
            onPostponeChange={onPostponeChange}
            path={generatePath(recommendationLinkUrl[key])}
            postponedDate={postponed ? new Date(postponed * 1000) : null}
            recommendationKey={key}
            showBottomBorder={showBottomBorder}
            startDate={startDate}
            subtitle={
                <LocaleWithCatalogName
                    catalogId={ProvidersIdsEnum.facebook}
                    namePlaceholder="FB"
                    stringKey={recommendationSubtitles[key]}
                />
            }
            tagCounterPluralLangKeys={recommendationTagCounterName[key]}
            title={
                <LocaleWithCatalogName
                    catalogId={ProvidersIdsEnum.facebook}
                    namePlaceholder="FB"
                    stringKey={recommendationTitles[key]}
                />
            }
        />
    );
}
